import React, { useState } from "react";
import PropTypes from "prop-types";

import { useMutation } from "react-apollo";
import { Fieldset, Field, Control, Button } from "rbx";

import { CREATE_NOTE_MUTATION } from "../../graphql/Notes/Notes.graphql";
import { ourToast as toast } from "../../utils";

import CustomerNoteForm from "./CustomerNoteForm";

const AddCustomerNoteForm = ({ id, onComplete }) => {
  const [inputs, setInputs] = useState({});

  const [createNote, { loading }] = useMutation(CREATE_NOTE_MUTATION);
  const handleSubmit = async e => {
    e.preventDefault();
    try {
      await createNote({
        variables: {
          data: { ...inputs, TableName: "Customers", RefRecId: parseInt(id) }
        },
        refetchQueries: ["ALL_NOTES_QUERY"]
      });
      toast.success("Note added successfully.");
      onComplete();
    } catch (err) {
      toast.error("Error adding Note.");
    }
  };
  const handleChange = e => {
    const updates = {};
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    if (/RecIdRef/.test(e.target.name)) {
      updates[e.target.name] = parseInt(e.target.value, 10);
    } else {
      updates[e.target.name] = value;
    }
    setInputs(prev => ({ ...prev, ...updates }));
  };
  return (
    <form method="POST" onSubmit={handleSubmit}>
      <Fieldset disabled={loading}>
        <CustomerNoteForm inputs={inputs} onChange={handleChange} />
        <hr />
        <Field kind="group">
          <Control>
            <Button color="primary" type="submit">
              Submit
            </Button>
          </Control>
          <Control>
            <Button type="button" onClick={onComplete}>
              Cancel
            </Button>
          </Control>
        </Field>
      </Fieldset>
    </form>
  );
};

AddCustomerNoteForm.propTypes = {
  id: PropTypes.number.isRequired,
  onComplete: PropTypes.func
};

export default AddCustomerNoteForm;
